import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/B4';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得電子通知單申請條款說明
export function getAgreeTermsB4() {
    return get(`${url}/getAgreeTerms`);
}

// 電子通知單申請條款同意
export function postAgreeB4() {
    return post(`${url}/agree`);
}

/**
 * 保戶進入申請電子通知單前，取得先前申請電子通知單記錄
 * @return {Object}
 * beforeApplyStatus true:已申請, false:未申請
 * applyAllById true=顯示選項:申請以您為要保人之所投保的所有有效保單
 * applyOneById true=顯示選項:申請本保單
 * cancelAllById true=顯示選項:終止以本保單之要保人所投保之所有有效保單
 * cancelOneByPoly true=顯示選項:終止本保單
 */
export function getInfoB4() {
    return get(`${url}/info`);
}

// 電子通知單送出申請
// 申請類型送出值:1(BY要保人申請)，2(BY要保人終止)，3(BY保單申請)，4(By保單終止)
export function submitB4(data) {
    return post(`${url}/submit`, { isCommit: data }, { ...options, repeatRequestCancel: true });
}
